import React from "react";
import { Subscribe } from "unstated";

import { myGlobals, myUtilities } from "../../Utils";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as retryReceiptAction from "../../redux/actions/retryReceiptAction";

import { globalVars } from "../../App";

class PaymentStatus extends React.Component {
  constructor(props) {
    super(props);
    this.setResponse = false;
    this.receiptRequest = false;
  }
  setPaymentState = (paymentData) => {
    if (this.props.isCreditCard && !this.setResponse) {
      this.setResponse = true;
      let data = this.props.creditCardResponse.split("@");
      paymentData.setPaymentData(data[3], data[2], data[4]);
    }else if(this.props.isDirectDebit && !this.setResponse){
    	this.setResponse = true;
      let data = this.props.directDebitResponse
    	paymentData.setPaymentData(data?.paymentId, data?.splitIds, data?.transactionID);
    }
  };
  downloadReceipt = (invData, fileName) => {
    if (globalVars.recieptDownloadCheck) {
      globalVars.recieptDownloadCheck = false;
      let token;
      if (invData.state.token) token = invData.state.token;
      else
        token = window.location.search.substring(
          7,
          window.location.search.length
        );
      fileName = fileName.trim();
      fileName =
        "/radiusoneweb/securedFileDownload?file=" +
        fileName +
        "&token=" +
        encodeURIComponent(token);
        this.downloadPaymentReceipt(
          fileName,
          myGlobals.globalAccountId + "Payment Receipt"
        );
    }
  };
  downloadPaymentReceipt = (urlForReceipt, fileName) => {
    let downloadLink = document.createElement("a");
    downloadLink.download = fileName;
    downloadLink.href = urlForReceipt;
    downloadLink.target = "_blank";
    downloadLink.click();
  };
  getPaymentStatus = (data, invData, fileDownloadFunction) => {
  	this.props.retryReceiptAction.updateReceiptCallBegin();
    let self = this;
    if (data.state.paymentStatus === true) {
      const searchParams = new URLSearchParams();
      searchParams.append(
        "supplierId",
        window.rsaEncrypt(invData.state.globalAccountId)
      );
      searchParams.append(
        "paymentHeaderId",
        window.rsaEncrypt(data.state.paymentId)
      );
      searchParams.append(
        "paymentSplitIds",
        window.rsaEncrypt(data.state.splitId)
      );

      let link = "generatePaymentReceiptWithoutLogin";
      link = myGlobals.initialHost + myGlobals.appender + link;

      if (!this.receiptRequest) {
        fetch(link, {
          method: "POST",
          body: searchParams,
        })
          .then(function (response) {
          self.props.retryReceiptAction.updateReceiptCallEnd();
            if (response.status !== 200) {
            self.props.retryReceiptAction.incrementFailedReceiptCallCount();
              console.log(
                "Looks like there was a problem. Status Code: " +
                  response.status
              );
              return;
            }
            return response.text();
          })
          .then(function (data) {
           if(myUtilities.isValidString(data)) {
              self.props.retryReceiptAction.markReceiptGenerated();
               fileDownloadFunction(invData, data);
           }
            else 
              self.props.retryReceiptAction.incrementFailedReceiptCallCount();
           
          })
          .catch(function (err) {
          	self.props.retryReceiptAction.updateReceiptCallEnd();
            self.props.retryReceiptAction.incrementFailedReceiptCallCount();
            console.log("Fetch Error :-S", err);
            //onFailure(err);
          });
        this.receiptRequest = true;
      }
    } else if (data.state.paymentStatus === false)
      myGlobals.getHistory.replace(`/paymentfailed`);
  };
  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Subscribe to={[InvoiceDataContainer]}>
            {(invData) => (
              <div>
                {this.setPaymentState(data)}
                {this.getPaymentStatus(data, invData, this.downloadReceipt)}
              </div>
            )}
          </Subscribe>
        )}
      </Subscribe>
    );
  }
  
    componentDidMount() { 
    window.triggerReceiptCall =  (data, invData) => {
      this.receiptRequest = false;
      this.getPaymentStatus(data, invData, this.downloadReceipt);
    };
   }
  
}

const mapDispatchToProps = (dispatch) => ({
  retryReceiptAction: bindActionCreators(retryReceiptAction, dispatch),
});
export default connect(null, mapDispatchToProps)(PaymentStatus);
